import { CustomButton } from '../../components/molecules/CustomButton';
import { useNavigate } from 'react-router';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-warm flex min-h-screen w-full items-center justify-center">
      <div className="flex w-full max-w-2xl flex-col items-center gap-6 rounded-lg p-10">
        <h1 className="text-secondary-500 font-lexend text-[12rem] leading-none font-bold tracking-tighter sm:text-[16rem]">
          404
        </h1>

        <div className="flex flex-col items-center gap-2">
          <h2 className="text-content font-lexend text-center text-4xl font-bold sm:text-5xl">
            Oopsie la tcheam
          </h2>
          <p className="text-content text-center text-lg opacity-80">
            Cette page n'existe pas...
          </p>
        </div>

        <div className="my-4 flex w-full items-center gap-4">
          <div className="bg-primary-500 h-1 flex-1 rounded-full"></div>
          <div className="bg-secondary-500 h-2 w-2 rounded-full"></div>
          <div className="bg-primary-500 h-1 flex-1 rounded-full"></div>
        </div>

        <div className="flex-1">
          <CustomButton
            onClick={() => navigate('/login')}
            title="Retour à l'accueil"
            color="primary"
          />
        </div>
      </div>
    </div>
  );
};
